import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Layout } from "../../components/Layout";
import { ArtData, SITE_DATA_PARTITIONS, MEDIUM_TYPE } from "../../../../types";
import { Api } from "../../api";
import { ART_LIST_URL, CART_URL, URLS } from "../../config";
import { ImageCarousel } from "../../components/ImageCarousel";
import { Button, BUTTON_COLORS, BUTTON_TYPE } from "../../components/Button";
import { useCart } from "../../providers/cart";
import { getAltText, isSameArt } from "../../utils/art";
import { Price } from "../../components/Price";
import { LikeBox } from "../../components/LikeBox";
export function ArtPost({ art }: { art: ArtData }) {
  const navigate = useNavigate();
  const {
    addItem,
    removeItem,
    cart: { items, slug },
  } = useCart();
  const dimensionKeys = ["w", "h", "d"] as const;

  // // Set page title
  // useEffect(() => {
  //   if (art) {
  //     document.title = `${art.title} | Doridium.com`;
  //   }
  // }, [art]);
  if (!art)
    return (
      <>
        {/* TODO: Add meta tags with React Helmet */}
        {/* <Head>
          <title>{router.query.slug} | Doridium.com </title>
          <link
            rel="canonical"
            href={
              import.meta.env.VITE_SITE_URL + "/art/" + router.query.slug
            }
            key="canonical"
          />
        </Head> */}
        <div>LOADING</div>
      </>
    );
  // const title = art.title + " | Doridium.com";
  // const tags = getMetaTags({
  //   title: art.title,
  //   type: "website",
  //   description: "By " + art.author,
  //   image: `${import.meta.env.VITE_SITE_URL}/images/size-lg/${art.images?.[0]?.path}`,
  //   url: "https://doridium.com/art/" + art.slug,
  //   twitterCard: "summary_large_image",
  //   twitterImageAlt: getAltText(art),
  //   siteName: "Doridium.com",
  // });
  return (
    <>
      {/* TODO: Add meta tags with React Helmet */}
      {/* <Head>
        <title>{title}</title>

        <link
          rel="canonical"
          href={import.meta.env.VITE_SITE_URL + "/art/" + art.slug}
          key="canonical"
        />
        {tags.map((tag) => (tag ? <meta key={tag.property} {...tag} /> : null))}
      </Head> */}
      <div className="max-w-[1080px] m-auto px-2 md:px-10">
        <Button
          btnColor="text"
          btnType="text"
          onClick={() => {
            navigate(ART_LIST_URL(art.isInProgress ? "in-progress" : "basic"));
          }}
        >
          Back to art list
        </Button>
        <div className=" text-textSecondary flex lg:flex-row flex-wrap flex-col items-stretch">
          <div className="flex-1 lg:flex-[1_0_40%] lg:min-w-[500px] flex justify-center p-2 ">
            <ImageCarousel
              alt={getAltText(art)}
              size={{ maxHeight: "60vh", maxWidth: "100%", z: 1 }}
              images={art.images}
            />
          </div>
          <div className=" self-stretch flex-1 lg:flex-[1_0_30%] flex flex-col justify-between p-2 min-h-[100px]">
            <div>
              <h1 className="">{art.title}</h1>
              <p className="text-sm ">by {art.author}</p>
              <div className="2xl:w-1/2"></div>
              <div className="pt-4">
                <h2>{art.description}</h2>
                {art.mediums?.length ? (
                  <p>
                    {art.mediums
                      .map(
                        (medium) =>
                          Object.values(MEDIUM_TYPE).find(
                            ({ key }) => key === medium,
                          )?.label ?? medium,
                      )
                      .join(", ")}
                  </p>
                ) : null}
                {art.dimensions &&
                Object.keys(art.dimensions).every(
                  (key) => !!art.dimensions[key as keyof typeof art.dimensions],
                ) ? (
                  <p>
                    {dimensionKeys
                      .filter((key) => !!art.dimensions[key])
                      .map(
                        (key) =>
                          art.dimensions[key] +
                          (art.dimensions.unit === "in" ? '"' : ""),
                      )
                      .join(" x ")}{" "}
                    ({dimensionKeys.map((key) => key.toUpperCase()).join(" x ")}
                    )
                  </p>
                ) : null}
              </div>
              <LikeBox slug={art.slug} />
            </div>

            <div>
              {art.currency && art.price ? (
                <p className={art.orderSlug ? "line-through" : ""}>
                  <Price item={art} />
                </p>
              ) : null}
              {art.orderSlug ? <p>SOLD</p> : null}

              {art.orderSlug || art.isInProgress ? null : items.find((item) =>
                  isSameArt(item, art),
                ) ? (
                <div className="2xl:w-1/2">
                  {/* <div className="flex flex-wrap"> */}
                  <Button
                    btnColor="nav"
                    btnType="small"
                    className="w-full"
                    onClick={() => removeItem(art)}
                  >
                    REMOVE FROM CART
                  </Button>
                  <Link
                    to={CART_URL()}
                    className={
                      "w-full inline-block text-center " +
                      BUTTON_COLORS.primary +
                      BUTTON_TYPE.small
                    }
                  >
                    GO TO CART
                  </Link>
                </div>
              ) : (
                <div className="2xl:w-1/2">
                  <Button
                    btnColor="primary"
                    btnType="small"
                    className="w-full"
                    onClick={() => addItem(art)}
                  >
                    ADD TO CART
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default function Art() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [art, setArt] = useState<ArtData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchArt() {
      if (!slug) {
        navigate("/");
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const { success, data, error } = await Api.get<ArtData>({
          type: SITE_DATA_PARTITIONS.ART,
          slug,
        });
        if (!success || !data) {
          setError(error ?? "Art not found");
          setLoading(false);
          // Redirect to 404 with error info
          const redirect = new URLSearchParams({
            reason: error ?? `${slug} art not found`,
            redirect: `/art/${slug}`,
          });
          navigate(`/404?${redirect}`);
          return;
        }

        setArt(data);
        setLoading(false);
      } catch (err: any) {
        console.error("Error fetching art:", err);
        setError(err.message ?? "Failed to load art");
        setLoading(false);
      }
    }

    fetchArt();
  }, [slug, navigate]);

  if (error) {
    return <div>Error loading art: {error}</div>;
  }

  return (
    <Layout
      loading={loading}
      headerStyle="sm"
      bgImage={
        art?.images?.[0]?.path
          ? "url(" +
            URLS.image(art.images[0].path, { useImageSize: "size-xl" }) +
            ")"
          : undefined
      }
    >
      {art ? <ArtPost art={art} /> : null}
    </Layout>
  );
}
